import React from 'react';
import { Header } from '../../node_modules/semantic-ui-react';

export default function Education(props) {
    return(
        <div className='section' id='education'>
            <Header as='h3'>
            Education
            </Header>
            <div className="section-content">
                    Ph.D. in <a href='https://cs.kaist.ac.kr'>School of Computing</a>, <a href='https://kaist.ac.kr'>KAIST</a>
                    <div class="detail"><b>Mar. 2020 - present</b></div>
                    M.S. in <a href='https://cs.kaist.ac.kr'>School of Computing</a>, <a href='https://kaist.ac.kr'>KAIST</a>
                    <div class="detail"><b>Mar. 2018 - Feb. 2020</b></div>
                    B.S. in <a href='https://cs.kaist.ac.kr'>School of Computing</a>, <a href='https://kaist.ac.kr'>KAIST</a>
                    <div class="detail"><b>Sep. 2013 - Feb. 2018</b> </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Education.jsx